var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('scrumbs',{attrs:{"pagename":"login"}}),_c('div',{staticClass:"mt-5"}),_c('formlogin')],1)}
var staticRenderFns = []

export { render, staticRenderFns }